export default "__VITE_ASSET__CNeCP3RI__"